import React, { createContext, useContext, useMemo } from 'react';
import useSSEConnection from '../hooks/useSSEConnection';

/**
 * Contexto central de eventos SSE.
 * Consumidores chamam useRealtime().on('tipo', handler).
 */
const RealtimeContext = createContext({ on: () => () => {} });

/**
 * @param {object}  props
 * @param {string|string[]|{company?:string,user?:string,groups?:string[],global?:string}} props.channels
 * @param {React.ReactNode} props.children
 * @param {string}  [props.sseBase]
 */
export function RealtimeProvider({ channels, children, sseBase }) {
  const { on } = useSSEConnection(channels, sseBase);

  const value = useMemo(() => ({ on }), [on]);

  return <RealtimeContext.Provider value={value}>{children}</RealtimeContext.Provider>;
}

export function useRealtime() {
  return useContext(RealtimeContext);
}